/**
 * "Just 5 minutes" (spec §9.19 starter timer): start tracking with a soft alarm; on alarm the UI
 * offers "keep going" or "stop and log". Device-local, never in the doc.
 */
import { create } from "zustand";

interface StarterState {
  /** taskId with an armed alarm and when it fires (ms) */
  armed: { taskId: string; at: number } | null;
  fired: { taskId: string } | null;
  arm(taskId: string, minutes: number): void;
  fire(): void;
  dismiss(): void;
}

let timer: ReturnType<typeof setTimeout> | null = null;

export const useStarter = create<StarterState>((set, get) => ({
  armed: null,
  fired: null,
  arm(taskId, minutes) {
    if (timer) clearTimeout(timer);
    const at = Date.now() + minutes * 60_000;
    set({ armed: { taskId, at }, fired: null });
    timer = setTimeout(() => get().fire(), minutes * 60_000);
  },
  fire() {
    const a = get().armed;
    if (!a) return;
    set({ armed: null, fired: { taskId: a.taskId } });
  },
  dismiss() {
    if (timer) clearTimeout(timer);
    timer = null;
    set({ armed: null, fired: null });
  },
}));

export const STARTER_MINUTES = 5;
